
import { toRefs } from 'vue'
import { useRouter} from 'vue-router'
export default {
  props: {
    url_list: {
      type: Array,
      detault: []
    },
    show_time: {
      type: Number,
      defaurl: 5000
    }
  },
  setup(props: any){
    const router = useRouter();
    const { url_list,  show_time} = toRefs(props)
    const itme_click_fn = (item: any) => {
      window.common.goTo(item.type, item.data ,router)
    }
    return {
        url_list,
        show_time,
        itme_click_fn
    }
}
}
